














































import { Component, Prop, Vue } from "vue-property-decorator";

import BSwitch from "../app/switchs/b-switch.vue";
import ChangeDeliteButtons from "../buttons/change-delite-buttons.vue";

import { IDictionary } from "@/@types/dictionary";

@Component({
  components: { BSwitch, ChangeDeliteButtons },
})
export default class DictionaryCard extends Vue {
  @Prop({ type: Object, default: null }) card!: IDictionary;

  idCard = "";

  quickChangeShow(show: boolean): void {
    this.$emit("updateCT", { show }, this.card._id);
  }
}
